import "./bootstrap";

import { createApp } from "vue";
window.Vue = require('vue');

import SliderComponent from "./components/SliderComponent";
import ModalComponent from "./components/ModalComponent";
import ModalBanner from "./components/ModalBanner";
import ModalComponentSus from "./components/ModalComponentSus";
import ModalComponentSuserr from "./components/ModalComponentSuserr";
import { mixins } from './utils'


const app = createApp({mixins: [mixins]});


app.component("slider-component", SliderComponent);
app.component("modal-component", ModalComponent);
app.component("modal-banner", ModalBanner);
app.component("modal-component-sus", ModalComponentSus);
app.component("modal-component-sus-err", ModalComponentSuserr);

app.mount("#app");
